var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"to":"/","icon":"","active-class":"no-active"}},[_c('v-icon',[_vm._v("mdi-home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }